import React, { useEffect, useState } from "react";
import { Grid, Box, InputAdornment, IconButton, Typography, Button } from "@mui/material";
import CustomTextField from "../../../../components/CustomTextField/CustomTextField";
import { Link } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useAuth } from "context/authContext";

const EmailPasswordFields = ({
  onChange,
  initialValues,
  setShowIcons,
}: any) => {
  const { updateUserPassword } = useAuth();

  const [formValues, setFormValues] = useState(initialValues);
  const [showPassword, setShowPassword] = useState(false); // State for toggling password visibility
  const [message, setMessage] = useState<{ type: string; text: string } | null>(null);
  const [loading, setLoading] = useState(false);



  useEffect(() => {
    onChange(formValues);

    // Check if the fields are filled and toggle the showIcons state
    setShowIcons((prevState: any) => ({
      ...prevState,
      emailPassword: !!formValues.email,
    }));
  }, [formValues]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValues((prevValues: any) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  // ✅ Handle Update Password Click
  const handleUpdatePassword = async () => {
    if (!formValues.password) {
      setMessage({ type: "error", text: "Password cannot be empty." });
      return;
    }

    setLoading(true);
    setMessage(null);

    const result = await updateUserPassword(formValues.password);
    if (result.success) {
      // ✅ Clear the password field after updating and then set update display password
      setFormValues((prevValues: any) => ({
        ...prevValues,
        password: "",
      }));

      setMessage({ type: result.success ? "success" : "error", text: result.message });
      // ✅ Optionally auto-hide message after 3 seconds
      setTimeout(() => {
        setMessage(null);
      }, 3000);
    } else {
      setMessage({ type: "error", text: result.message });
    }
    setLoading(false);
  };

  return (
    <Grid
      display={"flex"}
      gap={5}
      flexDirection={"column"}
      p={{ xs: 2, md: 5 }}
      mt={{ xs: 3, md: 0 }}
    >
      <Grid
        item
        xs={12}
        sm={6}
        display={"flex"}
        gap={1}
        flexDirection={"column"}
      >
        <label htmlFor="email" style={styleSheet.labelText}>
          Email Address
        </label>
        <Grid display={"flex"} gap={2} alignItems={"center"} flex={1}>
          <Box sx={{ flexGrow: 1 }}>
            <CustomTextField
              name="email"
              sx={{ width: "100%", maxWidth: "654px" }}
              value={formValues.email}
              onChange={handleChange}
              disabled={true}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sm={6}
        display={"flex"}
        gap={1}
        flexDirection={"column"}
      >
        <label htmlFor="password" style={styleSheet.labelText}>
          Password
        </label>
        <Grid display={"flex"} gap={2} alignItems={"center"} flex={1}>
          <Box sx={{ flexGrow: 1 }}>
            <CustomTextField
              name="password"
              type={showPassword ? "text" : "password"}
              sx={{ width: "100%", maxWidth: "654px" }}
              value={formValues.password}
              onChange={handleChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleTogglePasswordVisibility}>
                      {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Grid>
        {message && <Typography color={message.type === "error" ? "red" : "green"}>{message.text}</Typography>}

        {/* Update Password Button */}
        {/* <Button variant="contained" color="primary" onClick={handleUpdatePassword} disabled={loading}
       
        > */}
        <Box
          onClick={handleUpdatePassword}
          sx={{
            width: "100%",
            maxWidth: "654px",
            display: "flex",
            justifyContent: "flex-end",
            fontSize: "17px",
            fontWeight: 400,
            cursor: "pointer",
          }}
        >
          {loading ? "Updating..." : "Update Password"}
        </Box>

        {/* </Button> */}

        {/* <Box
          onClick={() => { }}
          sx={{
            width: "100%",
            maxWidth: "654px",
            display: "flex",
            justifyContent: "flex-end",
            fontSize: "17px",
            fontWeight: 400,
            cursor: "pointer",
          }}
        >
          <Link to="/reset-password">Update Password</Link>
        </Box> */}
      </Grid>
    </Grid>
  );
};

export default EmailPasswordFields;

const styleSheet = {
  labelText: {
    fontWeight: 400,
    fontSize: "17px",
    color: "#000000",
  },
};
